import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Storage } from "@ionic/storage";
import { Device } from "@ionic-native/device";
import 'rxjs/add/operator/timeout';
import {AlertController, Config, ModalController, Platform} from "ionic-angular";
import {CompanyUserTermsPage} from "../pages/company-user-terms/company-user-terms";
import { AppVersion } from "@ionic-native/app-version";
import * as semver from "semver";
import { OneSignalService } from "./one-signal.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()

export class ApiService {

  ENDPOINT_URL = 'https://api.mijninstallatiepas.nl/v1';
  //ENDPOINT_URL = 'https://nuc.ecologium.nl/maintenanz-api-stefan/public/v1';
  //ENDPOINT_URL = 'https://demo.mijninstallatiepas.nl/api/v1';

  API_KEY = '20ae9daa-207c-4a2d-ad48-311def54daab';
  timeout = 60000;

  active_subscriptions = [];
  logged_in_user: any = {};
  app_current_version = '';
  app_version = '';

  constructor(
    private http: HttpClient,
    private storage: Storage,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public platform: Platform,
    public appVersion: AppVersion,
    public oneSignal: OneSignalService,
    public translate: TranslateService,
    public config: Config,
    private device: Device
  ) {
    this.loadFromStorage();
    // Get app version
    this.platform.ready().then(() => {
      if(this.platform.is('cordova')) {
        this.appVersion.getVersionNumber().then((version) => {
          this.app_version = version;
        });
      }
    });
  }

  private loadFromStorage() {
    this.storage.get('active_subscriptions').then((val) => {
      if(val){
        this.active_subscriptions = JSON.parse(val);
      }
    });
    this.storage.get('logged_in_user').then((val) => {
      if(val){
        this.logged_in_user = JSON.parse(val);
      }
    });
  }

  private doPost(url, data, allowEmptyToken?){
    return new Promise((resolve, reject) => {
      this.storage.get('token').then((token) => {
        if (!token && !allowEmptyToken) {
          reject(-2);
        }
        let body = {
          auth: {
            token: token
          }
        };
        if(data != null){
          Object.assign(body, { data: data });
        }
        this.http.post(this.ENDPOINT_URL + url, body).timeout(this.timeout).subscribe(response => {
          // @ts-ignore
          if(response.result > 0){
            // @ts-ignore
            resolve(response.data);
          } else {
            reject(0);
          }
        }, (error) => {
          console.error(error);
          if(error.status > 0) {
            reject(error.status * -1);
          } else {
            reject(-1);
          }
        });
      }).catch(() => {
        reject(-3);
      });
    })
  }

  private doPostWithoutToken(url, data){
    return new Promise((resolve, reject) => {
      let body = {};
      if(data != null){
        Object.assign(body, { data: data });
      }
      this.http.post(this.ENDPOINT_URL + url, body).timeout(this.timeout).subscribe(response => {
        // @ts-ignore
        if(response.result > 0){
          // @ts-ignore
          resolve(response.data);
        } else {
          reject(0);
        }
      }, (error) => {
        console.error(error);
        if(error.status > 0) {
          reject(error.status * -1);
        } else {
          reject(-1);
        }
      });
    })
  }

  public login(username, password){
    return new Promise((resolve, reject) => {
      this.http.post(this.ENDPOINT_URL + '/auth/login' , {
        auth: {
          api_key: this.API_KEY,
          uuid: (this.device.uuid ? this.device.uuid : 'NO_UUID'),
          username: username,
          password: password
        }
      }).timeout(this.timeout).subscribe((response:any) => {
        // @ts-ignore
        if(response.result < 1 || !response.data || !response.data.auth || !response.data.auth.token) {
          reject(0);
        } else {
          // Save customer_terms
          this.storage.set('customer_terms', response.data.customer_terms);
          // Save active_subscriptions
          this.active_subscriptions = [];
          if(response.result > 0 && response.data && response.data.company_user && response.data.company_user.active_subscriptions){
            this.active_subscriptions = response.data.company_user.active_subscriptions;
            this.storage.set('active_subscriptions', JSON.stringify(this.active_subscriptions));
            this.logged_in_user = response.data.company_user;
            this.app_current_version = response.data.app_current_version;
            this.storage.set('logged_in_user', JSON.stringify(this.logged_in_user));
          }
          // Set language
          this.setLanguage(response);
          // Check company user terms
          if(response.result > 0 && response.data && response.data.company_user_terms && response.data.company_user_terms_version){
            this.hasAcceptedTerms(response.data.company_user_terms_version).then((accepted) => {
              if(!accepted){
                this.showTermsModal(response.data.company_user_terms_version, response.data.company_user_terms);
              }
            });
          }
          // Check app version
          if(!this.hasLatestAppVersion()){
            this.showVersionAlert();
          }
          // Clear previous_token
          this.storage.set('previous_token', '');
          // OneSignal
          this.setOneSignalId();
          // @ts-ignore
          this.storage.set('token', response.data.auth.token).then(() => {
            // @ts-ignore
            this.storage.set('logged_in_user_id', response.data.company_user.company_user_id).then(() => {
              resolve(1);
            }).catch(() => {
              reject(0);
            });
          }).catch(() => {
            reject(0);
          })
        }
      }, (error) => {
        console.error(error);
        reject(-1);
      });
    });
  }

  public loginByCompanyUserId(company_user_id){
    return new Promise((resolve, reject) => {
      this.storage.get('token').then((token) => {
        this.http.post(this.ENDPOINT_URL + '/auth/loginByCompanyUserId' , {
          auth: {
            api_key: this.API_KEY,
            uuid: (this.device.uuid ? this.device.uuid : 'NO_UUID'),
            token: token,
            company_user_id: company_user_id
          }
        }).timeout(this.timeout).subscribe((response:any) => {
          // @ts-ignore
          if(response.result < 1 || !response.data || !response.data.auth || !response.data.auth.token) {
            reject(0);
          } else {
            // Save active_subscriptions
            this.active_subscriptions = [];
            if(response.result > 0 && response.data && response.data.company_user && response.data.company_user.active_subscriptions){
              this.active_subscriptions = response.data.company_user.active_subscriptions;
              this.storage.set('active_subscriptions', JSON.stringify(this.active_subscriptions));
              this.logged_in_user = response.data.company_user;
              this.storage.set('logged_in_user', JSON.stringify(this.logged_in_user));
            }
            // Set language
            this.setLanguage(response);
            // Set previous_token
            this.storage.set('previous_token', token);
            // OneSignal
            this.setOneSignalId();
            // @ts-ignore
            this.storage.set('token', response.data.auth.token).then(() => {
              // @ts-ignore
              this.storage.set('logged_in_user_id', response.data.company_user.company_user_id).then(() => {
                resolve(1);
              }).catch(() => {
                reject(0);
              });
            }).catch(() => {
              reject(0);
            })
          }
        }, (error) => {
          console.error(error);
          reject(-1);
        });
      });
    });
  }

  loginToPreviousToken(){
    return new Promise((resolve, reject) => {
      this.storage.get('previous_token').then((previous_token) => {
        if(!previous_token){
          reject();
        }
        this.storage.set('token', previous_token).then(() => {
          this.isLoggedIn().then(() => {
            resolve();
          }).catch(() => {
            reject();
          })
        });
      });
    });
  }

  public hasActiveSubscription(id){
    if(this.active_subscriptions.length && this.active_subscriptions.indexOf(id) > -1){
      return true;
    }
    return false;
  }

  public isChildCompanyUser(){
    return this.hasActiveSubscription('CHILD_COMPANY_USER');
  }

  public hasProSubscription(unitType){
    if(
      (unitType === 1 && this.hasActiveSubscription('UNIT_CV_PRO')) ||
      (unitType === 2 && this.hasActiveSubscription('UNIT_VENTILATIE_PRO')) ||
      (unitType === 3 && this.hasActiveSubscription('UNIT_WATERONTHARDER_PRO')) ||
      (unitType === 4 && this.hasActiveSubscription('UNIT_HIJSTOESTEL_PRO')) ||
      (unitType === 5 && this.hasActiveSubscription('UNIT_AIRCO_PRO')) ||
      (unitType === 7 && this.hasActiveSubscription('UNIT_CV_PRO')) ||
      (unitType === 8 && this.hasActiveSubscription('BASIS')) ||
      (unitType === 9 && this.hasActiveSubscription('UNIT_GAS_OF_SFEERHAARD'))
    ){
      return true;
    }
    return false;
  }

  public hasLatestAppVersion(){
    if(!this.app_current_version || !this.app_version){
      return true;
    }
    return !semver.gt(this.app_current_version, this.app_version);
  }

  public setOneSignalId(){
    if(this.logged_in_user && this.logged_in_user.onesignal_id){
      this.oneSignal.setExternalUserId(this.logged_in_user.onesignal_id);
    }
  }

  public unsetOneSignalId(){
    this.oneSignal.setExternalUserId('');
  }

  public logout(){
    return new Promise((resolve, reject) => {
      this.storage.get('token').then((token) => {
        if(!token){
          resolve(1);
        }
        this.http.post(this.ENDPOINT_URL + '/auth/logout' , {
          auth: {
            token: token
          }
        }).timeout(this.timeout).subscribe(response => {
          // @ts-ignore
          if(response.result < 1){
            reject(-1);
          } else {
            this.storage.set('devices', '').then();
            this.storage.set('company_users', '').then();
            this.storage.set('logged_in_user', '').then();
            this.storage.set('token', '').then(() => {
              this.storage.set('logged_in_user_id', '0').then(() => {
                resolve(1);
              }).catch(() => {
                reject(0);
              });
            }).catch(() => {
              reject(0);
            });
            // OneSignal
            this.unsetOneSignalId();
          }
        }, (error) => {
          console.error(error);
          // if server error, reset token and logged_in_user_id anyway and resolve
          this.storage.set('token', '').then(() => {
            this.storage.set('logged_in_user_id', '0').then(() => {
              resolve(1);
            }).catch(() => {
              reject(0);
            });
          }).catch(() => {
            reject(0);
          });
          // OneSignal
          this.unsetOneSignalId();
        });
      });
    });
  }

  public isLoggedIn(){
    return new Promise((resolve, reject) => {
      this.storage.get('token').then((token) => {
        if(!token){
          reject(-1);
        } else {
          // Try to refresh token
          this.http.post(this.ENDPOINT_URL + '/auth/refresh' , {
            auth: {
              token: token
            }
          }).timeout(this.timeout).subscribe((response:any) => {
            // Call OK, check result and update token
            // @ts-ignore
            if(response.result < 1 || !response.data.auth || !response.data.auth.token){
              reject(0);
            } else {
              // Save active_subscriptions
              if(response.result > 0 && response.data && response.data.company_user && response.data.company_user.active_subscriptions){
                console.log('Updating active_subscriptions');
                this.active_subscriptions = response.data.company_user.active_subscriptions;
                this.storage.set('active_subscriptions', JSON.stringify(this.active_subscriptions));
                this.logged_in_user = response.data.company_user;
                this.app_current_version = response.data.app_current_version;
                this.storage.set('logged_in_user', JSON.stringify(this.logged_in_user));
                this.storage.set('logged_in_user_id', this.logged_in_user.company_user_id);
              }
              console.log(this.hasLatestAppVersion());
              // Set language
              this.setLanguage(response);
              // Check company user terms
              if(response.result > 0 && response.data && response.data.company_user_terms && response.data.company_user_terms_version){
                this.hasAcceptedTerms(response.data.company_user_terms_version).then((accepted) => {
                  if(!accepted){
                    this.showTermsModal(response.data.company_user_terms_version, response.data.company_user_terms);
                  }
                });
              }
              // Check app version
              if(!this.hasLatestAppVersion()){
                this.showVersionAlert();
              }
              // OneSignal
              this.setOneSignalId();
              // @ts-ignore
              this.storage.set('token', response.data.auth.token).then(() => {
                resolve(1);
              }).catch(() => {
                reject(0);
              });
            }
          }, (error) => {
            // If connection error, assume token is still valid
            console.error(error);
            resolve(1);
          });
        }
      }).catch(() => {
        reject(-2);
      });
    });
  }

  public refreshToken(){
    return new Promise((resolve, reject) => {
      this.doPost('/auth/refresh', null).then((response:any) => {
        // @ts-ignore
        if(response.result < 1 || !response.data.auth || !response.data.auth.token){
          reject(0);
        } else {
          // Save customer_terms
          this.storage.set('customer_terms', response.data.customer_terms);
          // Save active_subscriptions
          if(response.result > 0 && response.data && response.data.company_user && response.data.company_user.active_subscriptions){
            console.log('Updating active_subscriptions');
            this.active_subscriptions = response.data.company_user.active_subscriptions;
            this.storage.set('active_subscriptions', JSON.stringify(this.active_subscriptions));
            this.logged_in_user = response.data.company_user;
            this.app_current_version = response.data.app_current_version;
            this.storage.set('logged_in_user', JSON.stringify(this.logged_in_user));
          }
          // Set language
          this.setLanguage(response);
          // OneSignal
          this.setOneSignalId();
          // @ts-ignore
          this.storage.set('token', response.data.auth.token).then(() => {
            resolve(1);
          }).catch(() => {
            reject(0);
          });
        }
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  private setLanguage(response){
    // Set language
    if(response.result > 0 && response.data && response.data.company_user && response.data.company_user.preferred_lang){
      this.translate.use(response.data.company_user.preferred_lang);
      this.config.set('backButtonText', this.translate.instant('Terug'));
    }
  }

  public hasAcceptedTerms(version){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('company_user_terms_accepted_' + user_id).then((val) => {
          if(val == version){
            resolve(true);
          } else {
            resolve(false);
          }
        })
      })
    });
  }

  public showTermsModal(version, terms){
    this.modalCtrl.create(CompanyUserTermsPage, {
      version: version,
      terms: terms,
    }).present();
  }

  public showVersionAlert(){
    let appstore = 'appstore';
    if(this.platform.is('android')){
      appstore = 'Google Play Store';
    }
    if(this.platform.is('ios')){
      appstore = 'Apple Appstore';
    }
    this.alertCtrl.create({
      title: 'App versie',
      message: 'U gebruikt niet de nieuwste versie van de Maintenanz app. Ga naar de ' + appstore + ' om de nieuwste versie te downloaden.',
      cssClass: 'alert-error',
      buttons: ['OK']
    }).present();
  }

  public getProfile(){
    return new Promise((resolve, reject) => {
      this.doPost('/profile/me', null).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getLoggedInUser(){
    return this.logged_in_user;
  }

  public setProfile(data){
    return new Promise((resolve, reject) => {
      this.doPost('/profile/update', data).then(() => {
        resolve(1);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public setPassword(password){
    return new Promise((resolve, reject) => {
      this.doPost('/profile/password', {
        password: password
      }).then(() => {
        resolve();
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getWorkorders(){
    return new Promise((resolve, reject) => {
      this.doPost('/workorder/get', null).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public setWorkorders(data){
    return new Promise((resolve, reject) => {
      this.doPost('/workorder/set', data).then(() => {
        resolve(1);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public setXpWorkorders(data, email){
    return new Promise((resolve, reject) => {
      this.doPostWithoutToken('/xp/set', {
        email: email,
        workorders: data
      }).then(() => {
        resolve(1);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public addActivityLog(log_type, platform, version, uuid, content){
    return new Promise((resolve, reject) => {
      this.doPost('/activity_log/log', {
        log_type: log_type,
        platform: platform,
        version: version,
        uuid: uuid,
        content: content
      }, true).then(() => {
        resolve(1);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public deleteWorkorder(workorder_id){
    return new Promise((resolve, reject) => {
      let data = {
        id: workorder_id
      };
      this.doPost('/workorder/delete', data).then(() => {
        resolve(1);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public searchCustomer(query, type?){
    type = (type ? type : '');
    return new Promise((resolve, reject) => {
      this.doPost('/customer/search', {
        query: query,
        type: type
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public searchLocation(query, zipcode, number, search_type){
    return new Promise((resolve, reject) => {
      this.doPost('/location/search', {
        query: query,
        zipcode: zipcode,
        number: number,
        search_type: search_type,
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public searchLocationUnits(query, zipcode, number, search_type){
    return new Promise((resolve, reject) => {
      this.doPost('/unit/search', {
        query: query,
        zipcode: zipcode,
        number: number,
        search_type: search_type,
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public searchUnitModel(query){
    return new Promise((resolve, reject) => {
      this.doPost('/unitmodel/search', {
        query: query
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public searchUnitVersion(query, unit_type){
    return new Promise((resolve, reject) => {
      this.doPost('/unitversion/search', {
        query: query,
        unit_type: unit_type
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public searchPart(query){
    return new Promise((resolve, reject) => {
      this.doPost('/part/search', {
        query: query
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public getUnitByPassportNr(passport_nr, unit_id?){
    return new Promise((resolve, reject) => {
      this.doPost('/unit/one', {
        passport_nr: passport_nr,
        id: unit_id
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public checkQr(passport_nr){
    return new Promise((resolve, reject) => {
      this.doPost('/unit/checkqr', {
        passport_nr: passport_nr
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public getUnitBrands(){
    return new Promise((resolve, reject) => {
      this.doPost('/unitbrand/all', null).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getUnitVersionFiles(unit_version_id, unit_id, country){
    return new Promise((resolve, reject) => {
      this.doPost('/unitversion/files', {
        unit_version_id: unit_version_id,
        unit_id: unit_id,
        country: country
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getDevices(){
    return new Promise((resolve, reject) => {
      this.doPost('/device/all', null).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getCompanyUsers(){
    return new Promise((resolve, reject) => {
      this.doPost('/company_user/all', null).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getCompanyFiles(){
    return new Promise((resolve, reject) => {
      this.doPost('/company_file/all', null).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getAddressByPostcode(postcode, number, letter){
    return new Promise((resolve, reject) => {
      this.doPost('/postcode/get', {
        postcode: postcode,
        number: number,
        letter: letter
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  public getNews(){
    const language = this.translate.currentLang;
    return new Promise((resolve, reject) => {
      this.doPostWithoutToken('/news/get', {
        language: language
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getHomeNews(){
    const language = this.translate.currentLang;
    return new Promise((resolve, reject) => {
      this.doPost('/news/home', {
        language: language
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getCompanyParents(){
    return new Promise((resolve, reject) => {
      this.doPost('/company_parent/all', null).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public getOpenedImportantNews(news_id){
    return new Promise((resolve) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('opened_important_news_' + user_id).then((val) => {
          let opened_news = (val ? JSON.parse(val) : []);
          let isOpened = opened_news.includes(news_id);
          resolve(isOpened);
        }).catch(() => {
          resolve(false);
        });
      }).catch(() => {
        resolve(false);
      });
    });
  }

  public setOpenedImportantNews(news_id){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('opened_important_news_' + user_id).then((val) => {
          let opened_news = (val ? JSON.parse(val) : []);
          if (!opened_news.includes(news_id)) {
            opened_news.push(news_id);
            this.storage.set('opened_important_news_' + user_id, JSON.stringify(opened_news)).then(() => {
              resolve(1);
            }).catch(() => {
              reject(0);
            });
          } else {
            resolve(1);
          }
        }).catch(() => {
          // if local storage does not exist yet
          let opened_news = [news_id];
          this.storage.set('opened_important_news_' + user_id, JSON.stringify(opened_news)).then(() => {
            resolve(1);
          }).catch(() => {
            reject(0);
          });
        });
      }).catch(() => {
        reject(0);
      });
    });
  }

  public uploadFile(base64_string, filename?, target?, type?){
    type = (type ? type : 'file');
    target = (target ? target : 'workorder');
    filename = (filename ? filename : '');
    return new Promise((resolve, reject) => {
      this.doPost('/file/upload', {
        base64_string: base64_string,
        type: type,
        target: target,
        filename: filename
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  public uploadPhoto(base64_string, target?){
    target = (target ? target : 'workorder');
    return this.uploadFile(base64_string, '', target, 'photo');
  }

}



// WEBPACK FOOTER //
// ./src/services/api.service.ts